import { Component } from '@angular/core';

@Component({
  selector: 'app-auth',
  template: `
    <div class="login-container">
      <router-outlet></router-outlet>
    </div>
  `,
  styles: [`
    .login-container {
        height: 100vh;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, var(--primary-color) 0%, #1e166b 100%);
    }
  `]
})
export class AuthComponent {}
